import { SetActiveCompanyDasboardAction, SET_ACTIVE_COMPANY_DASHBOARD } from './types'

export const setActiveDashboard = (payload: number | null): SetActiveCompanyDasboardAction => ({
  type: SET_ACTIVE_COMPANY_DASHBOARD,
  payload
})
